import { Injectable, Inject } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { environment } from '@perval/shared';

@Injectable({ providedIn: 'root' })
export class GtmService {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {}

  init() {
    if (!isPlatformBrowser(this.platformId)) return; // SSR safe

    const gtmId = environment.gtmCode;
    if (!gtmId || gtmId === 'default') {
      console.warn('GTM ID manquant : aucun script injecté.');
      return;
    }

    // Déjà initialisé ?
    if (this.document.getElementById('gtm-script')) return;

    // --- Inject GTM <script> dans <head> ---
    const script = this.document.createElement('script');
    script.id = 'gtm-script';
    script.async = true;
    script.text = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmId}');
    `;
    this.document.head.appendChild(script);

    // --- Inject GTM <noscript> dans <body> ---
    const noscript = this.document.createElement('noscript');
    noscript.id = 'gtm-noscript';
    noscript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
    this.document.body.prepend(noscript);
  }
}
